import { mapServerSideTariff } from '@/utils/api.mapper'
import { getInstanceWithToken } from '@/utils/axios'
import {
  ServerSideTariff,
  Tariff,
  ServerSidePromotionalPage,
  PromotionalPageRequest,
  PromotionalPage,
  ServerSideTariffPromotionalPage, PromotionalPageRequestUpdate
} from './types'

export interface FetchTariffRequest {
  appId?: number
}

export const fetchTariffs = async (req: FetchTariffRequest): Promise<Tariff[]> => {
  const { data } = await getInstanceWithToken().get<ServerSideTariff[]>('api/tariffs', {
    params: {
      app: req.appId ? `/api/apps/${req.appId}` : undefined,
    },
  })

  return data.map(mapServerSideTariff)
}

export interface CreateTariffRequest {
  appId: number
  type: number
  name: string
  amount: string
  period: number
}

export const createTariff = async (req: CreateTariffRequest): Promise<Tariff> => {
  const { data } = await getInstanceWithToken().post<ServerSideTariff>('api/tariffs', {
    app: `/api/apps/${req.appId}`,
    type: req.type,
    name: req.name,
    amount: req.amount,
    period: req.period,
  })

  return mapServerSideTariff(data)
}

export interface UpdateTariffRequest {
  id: number
  type?: number
  name?: string
  amount?: string
  period?: number
}

export const updateTariff = async (req: UpdateTariffRequest): Promise<Tariff> => {
  const { data } = await getInstanceWithToken().put<ServerSideTariff>(`api/tariffs/${req.id}`, {
    type: req.type,
    name: req.name,
    amount: req.amount,
    period: req.period,
  })

  return mapServerSideTariff(data)
}

export const createPromotionalPage = async (req: PromotionalPageRequest):
    Promise<PromotionalPage> => {
  const {data} = await getInstanceWithToken().post<ServerSidePromotionalPage>('/api/promotional_pages', req)
  return {
    tariffs: data.tariffs,
    status: data.status,
    created: data.created,
    updated: data.updated,
    designType: data.designType,
    id: data.id,
    name: data.name
  }
}

export const updatePromotionalPage = async (req: PromotionalPageRequestUpdate):
    Promise<PromotionalPage> => {
     
  const {data} = await getInstanceWithToken().put<ServerSidePromotionalPage>(`/api/promotional_pages/${req.id}`, {
    tariffs: req.tariffs,
    name: req.name
  })
  return {
    tariffs: data.tariffs,
    status: data.status,
    created: data.created,
    updated: data.updated,
    designType: data.designType,
    id: data.id,
    name: data.name
  }
}

export default fetchTariffs
